/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Exercise_ContraindicatedInputs */

const en_us2_plan_exercise_contraindicated = /** @type {(inputs: Plan_Exercise_ContraindicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That exercise does not suit an injury you recorded, so it stays out of the plan.`)
};

const pt_br2_plan_exercise_contraindicated = /** @type {(inputs: Plan_Exercise_ContraindicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse exercício não combina com uma lesão que você registrou, então não entra no plano.`)
};

const es_419_plan_exercise_contraindicated = /** @type {(inputs: Plan_Exercise_ContraindicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese ejercicio no es adecuado para una lesión que registraste, así que queda fuera del plan.`)
};

const pt_pt2_plan_exercise_contraindicated = /** @type {(inputs: Plan_Exercise_ContraindicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse exercício não é adequado a uma lesão que registaste, por isso não entra no plano.`)
};

const fr_fr2_plan_exercise_contraindicated = /** @type {(inputs: Plan_Exercise_ContraindicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet exercice ne convient pas à une blessure que tu as enregistrée, il reste donc hors du programme.`)
};

const de_de2_plan_exercise_contraindicated = /** @type {(inputs: Plan_Exercise_ContraindicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Übung passt nicht zu einer Verletzung, die du eingetragen hast, daher bleibt sie aus dem Plan.`)
};

const it_it2_plan_exercise_contraindicated = /** @type {(inputs: Plan_Exercise_ContraindicatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quell'esercizio non è adatto a un infortunio che hai registrato, quindi resta fuori dalla scheda.`)
};

/**
* | output |
* | --- |
* | "That exercise does not suit an injury you recorded, so it stays out of the plan." |
*
* @param {Plan_Exercise_ContraindicatedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_exercise_contraindicated = /** @type {((inputs?: Plan_Exercise_ContraindicatedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Exercise_ContraindicatedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_exercise_contraindicated(inputs)
	if (locale === "es-419") return es_419_plan_exercise_contraindicated(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_exercise_contraindicated(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_exercise_contraindicated(inputs)
	if (locale === "de-DE") return de_de2_plan_exercise_contraindicated(inputs)
	if (locale === "it-IT") return it_it2_plan_exercise_contraindicated(inputs)
	return en_us2_plan_exercise_contraindicated(inputs)
});
export { plan_exercise_contraindicated as "plan.exercise_contraindicated" }